<template>
  <div class="narrow-panel">
    <p class="narrow-panel__hint">
      {{
        $t(
          "dashboard.donor_communication_prefs_narrow_hint",
          "Select the campaigns you do NOT want to hear about. All other campaigns will be able to contact you."
        )
      }}
    </p>

    <div v-if="campaigns.length" class="narrow-panel__list">
      <b-form-checkbox
        v-for="campaign in campaigns"
        :key="campaign.id"
        v-model="selected"
        :value="campaign.id"
        :disabled="busy"
      >
        {{ campaign.name }}
        <span v-if="campaign.orgName" class="narrow-panel__org">— {{ campaign.orgName }}</span>
      </b-form-checkbox>
    </div>
    <p v-else class="narrow-panel__empty">
      {{
        $t(
          "dashboard.donor_communication_prefs_no_campaigns",
          "No campaigns to manage yet — campaigns appear here after you donate."
        )
      }}
    </p>

    <div v-if="confirming" class="narrow-panel__confirm">
      <p class="narrow-panel__confirm-msg">{{ confirmMsg }}</p>
      <div class="narrow-panel__footer">
        <button class="bttn bttn--sm bttn--blue" :disabled="busy" @click="confirming = false">
          {{ $t("dashboard.donor_settings_confirm_no_btn", "No") }}
        </button>
        <button class="bttn bttn--sm bttn--orange" :disabled="busy" @click="submit">
          {{ $t("dashboard.donor_settings_confirm_yes_btn", "Yes") }}
        </button>
      </div>
    </div>
    <div v-else class="narrow-panel__footer">
      <button class="bttn bttn--sm bttn--blue" :disabled="busy" @click="$emit('cancel')">
        {{ $t("dashboard.donor_communication_prefs_narrow_cancel_btn", "Cancel") }}
      </button>
      <button class="bttn bttn--sm bttn--orange" :disabled="busy" @click="confirming = true">
        {{ $t("dashboard.donor_communication_prefs_narrow_submit_btn", "Update preferences") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaigns: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.campaigns.filter((c) => c.unsubscribed).map((c) => c.id),
      confirming: false,
    };
  },
  computed: {
    confirmMsg() {
      return this.selected.length === 0
        ? this.$t(
            "dashboard.donor_communication_prefs_narrow_confirm_all",
            "This will subscribe you to all communications on this channel. Continue?"
          )
        : this.$t(
            "dashboard.donor_communication_prefs_narrow_confirm",
            "This will turn messages back on except for the campaigns you selected. Continue?"
          );
    },
  },
  methods: {
    submit() {
      this.$emit("submit", this.selected.map(Number));
    },
  },
};
</script>

<style lang="scss" scoped>
.narrow-panel {
  margin-top: 15px;
  padding: 20px;
  border: 1px solid #e6eaed;
  border-radius: 4px;
  &__hint {
    font-size: 16px;
    margin-bottom: 15px;
  }
  &__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 16px;
  }
  &__org {
    color: #7c8a97;
    font-size: 14px;
  }
  &__empty {
    font-size: 16px;
    color: #7c8a97;
  }
  &__confirm-msg {
    font-size: 16px;
    margin: 20px 0 0;
    font-weight: bold;
  }
  &__footer {
    display: flex;
    gap: 10px;
    margin-top: 20px;
  }
}
</style>
